import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'

import './Header.scss'
import burger from '../../assets/svg/burger.svg'
import searchIcon from '../../assets/svg/search.svg'
import Logo from '../Logo/Logo'

const PropertyHeader = ({ active, pageData }: any): JSX.Element => {
  const { pageContext } = pageData
  const pageLocation = pageData.location.pathname

  const watchScroll = (): void => {
    const bs1: any = document.querySelector('.menu-base-details')
    const bs2: any = document.querySelector('.property-base-menu')

    const footerBreakPoint = 700
    window.onscroll = (): void => {
      if (window.scrollY > footerBreakPoint) {
        if (bs1) {
          bs1.classList.replace('slide-in-bottom', 'slide-out-bottom')
        }
        if (bs2) {
          bs2.classList.replace('slide-in-bottom', 'slide-out-bottom')
        }
      } else {
        if (bs1) {
          bs1.classList.replace('slide-out-bottom', 'slide-in-bottom')
          bs1.classList.replace('base-menu', 'slide-in-bottom')
        }
        if (bs2) {
          bs2.classList.replace('slide-out-bottom', 'slide-in-bottom')
          bs2.classList.replace('base-menu', 'slide-in-bottom')
        }
      }
    }
  }

  interface Links {
    name: string
    url: string
    type?: string
  }

  const navLinks = [
    {
      id: 1,
      name: 'Home',
      url: '/'
    },
    {
      id: 2,
      name: 'Our Properties',
      url: '/properties'
    },
    {
      id: 3,
      name: 'Destinations',
      url: '/destinations'
    },
    {
      id: 4,
      name: 'News and Events',
      url: '/news-and-events'
    },
    {
      id: 5,
      name: 'Homebuying Guide',
      url: '/homebuying-guide'
    },
    {
      id: 6,
      name: 'Sellers Home',
      url: '/sellers-home'
    },
    {
      id: 7,
      name: 'Careers',
      url: '/careers'
    }
  ]

  const socialLinks = [
    {
      id: 1,
      name: 'facebook',
      link: 'https://www.facebook.com/AyalaLandInternationalSalesOfficial/'
    },
    {
      id: 2,
      name: 'instagram',
      link: 'https://www.instagram.com/ayalalandinternationalsalesinc/'
    },
    {
      id: 3,
      name: 'youtube',
      link: 'https://www.youtube.com/channel/UCUZKchCWvPFSGS8DXSOaOXw'
    },
    {
      id: 4,
      name: 'twitter',
      link: 'https://twitter.com/wwwatayalacom?lang=en'
    }
  ]

  const mapPropertyURL = (pagePath: string): string => {
    let mappedPath = ''
    const splitPath = pageLocation.split('/')
    splitPath[3] = pagePath
    mappedPath = splitPath.join('/')
    return mappedPath
  }

  let propertyLinks = [
    {
      id: 1,
      name: 'Overview',
      link: mapPropertyURL('overview')
    },
    {
      id: 2,
      name: 'Location',
      link: mapPropertyURL('location')
    },
    {
      id: 3,
      name: 'Units & Floor Plans',
      link: mapPropertyURL('units-and-floor-plans')
    },
    {
      id: 4,
      name: 'Features & Amenities',
      link: mapPropertyURL('features-and-amenities')
    },
    {
      id: 5,
      name: 'Construction Updates',
      link: mapPropertyURL('construction-updates')
    }
  ]

  if (pageContext.brand === 'alp') {
    propertyLinks = [
      {
        id: 1,
        name: 'Overview',
        link: mapPropertyURL('overview')
      },
      {
        id: 2,
        name: 'Location',
        link: mapPropertyURL('location')
      },
      {
        id: 3,
        name: 'Units & Floor Plans',
        link: mapPropertyURL('units-and-floor-plans')
      }
    ]
  }

  const [menu, setMenu] = useState<boolean>(false)

  const toggleMenu = (): void => {
    setMenu(!menu)
  }

  useEffect(() => {
    watchScroll()
  }, [])

  return (
    <>
      <div className="header property-header solid">
        <Link to="/" className="logo-link">
          <Logo fill="#fff" size={70} id="header-logo" />
        </Link>

        <div className="nav-wrapper" id="mid-nav">
          <div className="nav-items">
            <div className="menu-links">
              {navLinks &&
                navLinks.slice(1, 5).map((item: Links) => {
                  return (
                    <a href={item.url} key={Math.random()}>
                      {item.name}
                    </a>
                  )
                })}
            </div>
          </div>
        </div>

        <div className="nav-wrapper">
          <div className="nav-items">
            <a href="/search">
              <img src={searchIcon} alt="search icon" className="svg-icon" />
              <span className="nav-text">search</span>
            </a>
            <a href="#menu" onClick={toggleMenu}>
              <img src={burger} alt="burger icon" className="svg-icon" />
              <span className="nav-text">menu</span>
            </a>
          </div>
        </div>
      </div>

      <div className="property-navigation">
        {propertyLinks.map((item: any, index: number) => {
          return (
            <Link to={item.link} key={index}>
              <span className={active === item.id ? 'active' : ''}>{item.name}</span>
            </Link>
          )
        })}
      </div>

      {menu && (
        <>
          <div className="nav-menu-wrapper fade-in" role="button" onClick={toggleMenu} />
          <div className="menu-sidebar slide-in-right">
            <i className="la la-close close-btn la-2x" onClick={toggleMenu} />

            <div className="menu-links" id="mobile-property-menu">
              {propertyLinks &&
                propertyLinks.map((item: any) => {
                  return (
                    <>
                      <a href={item.link} key={Math.random()} className="property-link">
                        <div>
                          <span>{item.name}</span>
                          {item.type ? <i className="la la-angle-down" /> : ''}
                        </div>
                      </a>
                      <br />
                    </>
                  )
                })}
            </div>

            <div className="menu-links">
              {navLinks &&
                navLinks.map((item: Links) => {
                  return (
                    <a href={item.url} key={Math.random()}>
                      <div>
                        <span>{item.name}</span>
                        {item.type ? <i className="la la-angle-down" /> : ''}
                      </div>
                    </a>
                  )
                })}
            </div>

            <div className="menu-footer">
              <div className="menu-footer-content">
                <div className="social-links">
                  {socialLinks &&
                    socialLinks.map((item: { link: string; name: string }) => {
                      return (
                        <a href={item.link} target="_blank" rel="noreferrer" key={Math.random()} title={item.link}>
                          <i className={`la la-${item.name}`} />
                        </a>
                      )
                    })}
                </div>

                <div className="footer-credits">
                  <small>Powered By:</small>
                  <a href="https://whitecloak.com" target="_blank" rel="noreferrer">
                    White Cloak Technologies Inc.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default PropertyHeader
